<template>
  <b-modal
    v-model="show"
    :title="$t('EMPLOYEE VACATIONS')"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('close')"
    size="lg"
    scrollable
  >
    <div class="mb-2 mt-1">
      <b-row>
        <b-col sm="6">
          <b-input-group class="mb-1">
            <template #prepend>
              <b-input-group-text class="prepend__width">
                <strong>{{ $t("TYPE") }}</strong>
              </b-input-group-text>
            </template>
            <b-form-input :value="$t(data.personal_type)" disabled />
          </b-input-group>
        </b-col>
        <b-col sm="6">
          <b-input-group class="mb-1">
            <template #prepend>
              <b-input-group-text class="prepend__width">
                <strong>{{ $t("EMPLOYEE") }}</strong>
              </b-input-group-text>
            </template>
            <b-form-input :value="data.employee" disabled />
          </b-input-group>
        </b-col>
      </b-row>
    </div>

    <div class="table-responsive" v-if="data.vacations">
      <b-table
        small
        sticky-header="50vh"
        class="position-relative"
        table-class="text-nowrap"
        :items="JSON.parse(data.vacations)"
        :fields="fields"
      >
        <template #cell(month)="data">
          <span>
            {{ data.item.month | globalDate }}
          </span>
        </template>
      </b-table>
    </div>
  </b-modal>
</template>

<script>
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";

export default {
  props: {
    employeeId: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      show: true,
      data: {},
      fields: [
        {
          key: "month",
          label: this.$t("MONTH"),
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "worked_days",
          label: this.$t("WORKED DAYS"),
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "days",
          label: this.$t("DAYS"),
          tdClass: "text-center",
          thClass: "text-center",
        },
      ],
    };
  },
  async mounted() {
    await this.getEmployeeVacations();
  },
  methods: {
    async getEmployeeVacations() {
      try {
        this.addPreloader();
        const params = {
          employee_id: this.employeeId,
        };
        const { data } = await EmployeeService.getEmployeeVacations(params);
        this.data = data[0];
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style scoped>
.py-1s {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>